if (!customElements.get('portrait-preset-gallery')) {
  customElements.define('portrait-preset-gallery', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.track = this.querySelector('.preset-gallery__track');
        this.slides = [...this.track.children].filter(el => el.tagName.toLowerCase().startsWith('before-after-comparison-'));
        this.prev = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');
        this.count = this.querySelector('[data-gallery-count]');
        this.index = 0;
        this.prev.onclick = () => this.show(this.index - 1);
        this.next.onclick = () => this.show(this.index + 1);
        this.selectBlock = event => {
          const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (i >= 0) this.show(i);
        };
        this.addEventListener('shopify:block:select', this.selectBlock);
        this.show(0);
      });
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.count.textContent = `${this.index + 1} of ${this.slides.length}`;
      this.prev.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      if (this.prev) this.prev.onclick = null;
      if (this.next) this.next.onclick = null;
    }
  });
}
